import { useState, useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import useSettingsStorage from 'Hooks/useSettingsStorage';
import { cn } from 'Utils/cn';
import AppLayoutSidebarDesktop from './AppLayoutSidebarDesktop';
import AppLayoutDesktopUserMenu from './AppLayoutDesktopUserMenu';
import { Slot } from 'nano-slots';
import AppLayoutHorizontalScroll from './AppLayoutHorizontalScroll';
import AppLayoutNotices from './AppLayoutNotices';

export default function AppLayoutDesktop() {
    const [expanded, setExpanded] = useState(false);
    const { isLoading, settings } = useSettingsStorage();

    const isMenuCollapsed = !isLoading && settings?.is_menu_collapsed?.value;

    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const from = sessionStorage.getItem('redirect');
        if (from) {
            sessionStorage.removeItem('redirect');

            if (from !== pathname) {
                navigate(from, { replace: true });
            }
        }
    }, []);

    const handleHover = () => {
        setExpanded(true);
    };

    const handleLeave = () => {
        setExpanded(false);
    };

    const collapsed = isMenuCollapsed && !expanded;

    return (
        <>
            <div className="min-h-dvh">
                <div
                    className={cn('h-full', !isMenuCollapsed ? 'pl-(--sidebar-width)' : 'pl-(--sidebar-width-narrow)')}
                >
                    <AppLayoutNotices />

                    <header className="h-15 bg-white flex items-center justify-between">
                        <div className="grow h-full">
                            <AppLayoutHorizontalScroll>
                                <Slot name="app-header" />
                                <Slot name="app-header-actions" />
                            </AppLayoutHorizontalScroll>
                        </div>

                        <div className="flex items-center pr-3">
                            <div className="pl-2">
                                <AppLayoutDesktopUserMenu />
                            </div>
                        </div>
                    </header>

                    <div
                        className={cn(
                            'fixed bg-white ring ring-black/5 top-0 left-0 bottom-0 overflow-x-hidden z-fixed transition-[width] duration-200 ease-in-out',
                            collapsed ? 'w-(--sidebar-width-narrow)' : 'w-(--sidebar-width)',
                        )}
                        onMouseEnter={handleHover}
                        onMouseLeave={handleLeave}
                    >
                        <AppLayoutSidebarDesktop collapsed={collapsed} onClose={handleLeave} />
                    </div>

                    <div>
                        <main>
                            <Outlet />
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}
